export default __webpack_public_path__ + "static/wolfgang-6fd2576a5c17618184152c8689ace018.gif";